var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 22 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e3kinzbtwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 748",
    style: {
      fill: "none"
    },
    d: "M0 0h15.016v15.16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 183"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 182",
    transform: "translate(.882 .829)",
    style: {
      clipPath: "url(#e3kinzbtwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 572",
    d: "M10.944 16.32H2.087A1.829 1.829 0 0 1 .2 14.559v-5.25a1.829 1.829 0 0 1 1.887-1.762h8.857a1.829 1.829 0 0 1 1.886 1.762v5.25a1.829 1.829 0 0 1-1.887 1.762M2.087 8.156A1.2 1.2 0 0 0 .852 9.309v5.25a1.2 1.2 0 0 0 1.235 1.153h8.857a1.2 1.2 0 0 0 1.235-1.153v-5.25a1.2 1.2 0 0 0-1.235-1.153z",
    transform: "translate(.993 -2.273)",
    style: {
      fill: "#13249f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 574",
    d: "M11.337 4.96a.316.316 0 0 1-.326-.3V3A2.271 2.271 0 0 0 8.668.809 2.271 2.271 0 0 0 6.325 3v1.656a.327.327 0 0 1-.652 0V3A2.9 2.9 0 0 1 8.668.2 2.9 2.9 0 0 1 11.662 3v1.656a.316.316 0 0 1-.326.3",
    transform: "translate(-1.16 .913)",
    style: {
      fill: "#13249f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 576",
    d: "M11.962 17.216H3.069a.305.305 0 1 1 0-.609h8.893a.305.305 0 1 1 0 .609",
    transform: "translate(-.008 -6.203)",
    style: {
      fill: "#13249f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.327c5453c3d918654b275442ff114158.svg";
export { ForwardRef as ReactComponent };